import React, { useEffect, useState } from 'react';
import logo from "./assets/images/logo.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBusinessTime, faCar, faClinicMedical, faEarthAfrica, faEarthAmerica, faEarthAmericas, faEarthOceania, faHeadset, faIndustry, faLifeRing, faStarOfLife, faUser, faUsers, faWineGlass, faXmark } from '@fortawesome/free-solid-svg-icons';

import { Link, useLocation } from 'react-router-dom';

const menu: any = {
  "Auto": {
    "Car insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#0085FF" }}><FontAwesomeIcon icon={faCar} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    }
  },
  "Medical": {
    "Group medical insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#FF6677" }}><FontAwesomeIcon icon={faUser} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Individual medical insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#FF6677" }}><FontAwesomeIcon icon={faUsers} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    }
  },
  "General": {
    "Contractor All Risk": {
      icon: <div className="icon" style={{ backgroundColor: "#15bd36" }}><FontAwesomeIcon icon={faLifeRing} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "SME Business Secure": {
      icon: <div className="icon" style={{ backgroundColor: "#15bd36" }}><FontAwesomeIcon icon={faBusinessTime} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Industrial & Warehouse": {
      icon: <div className="icon" style={{ backgroundColor: "#15bd36" }}><FontAwesomeIcon icon={faIndustry} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Multi Package": {
      icon: <div className="icon" style={{ backgroundColor: "#15bd36" }}><FontAwesomeIcon icon={faStarOfLife} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    }
  },
  "Group": {
    "Global insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#00a360" }}><FontAwesomeIcon icon={faEarthOceania} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "International insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#00a360" }}><FontAwesomeIcon icon={faEarthAfrica} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Local insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#00a360" }}><FontAwesomeIcon icon={faEarthAmerica} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Regional insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#00a360" }}><FontAwesomeIcon icon={faEarthAmericas} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    }
  },
  "Business": {
    "Business Insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faBusinessTime} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Office Insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faHeadset} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Restaurant Insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faWineGlass} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Clinic Insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faClinicMedical} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    },
    "Pharmacy Insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faStarOfLife} color="#FFFFFF" /></div>,
      link: "#"
    },
    "Shop insurance": {
      icon: <div className="icon" style={{ backgroundColor: "#eb971a" }}><FontAwesomeIcon icon={faCar} color="#FFFFFF" /></div>,
      link: "https://www.click2secure.me/index.php"
    }
  },
  "CarzData": {
    link: "https://carzdata.com"
  }
}

function App() {

  const [sideMenu, setSideMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState<null | number>(null);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <header>
        <div className="section__content">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="logo" width={150} />
            </Link>
          </div>
          {Object.keys(menu).map((item) => <div className="menu-item onlyweb">
            {menu[item].link ? <Link to={menu[item].link} target="_blank"><span>{item}</span></Link> : <span>{item}</span>}

            {!menu[item].link && <div className="dropdown">
              {Object.keys(menu[item]).map((item2) => <Link to={menu[item][item2].link}>
                <div className="dropdown__item">
                  {menu[item][item2].icon}
                  {item2}
                </div>
              </Link>)}
            </div>}
          </div>)}

          <div className="mobile-menu-icon onlymobile" onClick={() => setSideMenu(true)}>
            <FontAwesomeIcon icon={faBars} color='#222222' />
          </div>
        </div>

        <div className={"full-screen-menu" + (sideMenu ? " active" : "")} style={{ top: window.screenY }}>
          {Object.keys(menu).map((item, index) => <div className="mobile-menu-item">
            {menu[item].link ? <Link to={menu[item].link} target="_blank"><span>{item}</span></Link> : <span onClick={() => setActiveMenu(index)}>{item}</span>}

            {index === activeMenu && <div className="dropdown">
              {Object.keys(menu[item]).map((item2) => <Link to={menu[item][item2].link} onClick={() => setSideMenu(false)}>
                <div className="dropdown__item">
                  {menu[item][item2].icon}
                  {item2}
                </div>
              </Link>)}
            </div>}
          </div>)}
          <FontAwesomeIcon icon={faXmark} onClick={() => setSideMenu(false)} size="xl" />
        </div>
      </header>

      <div style={{ height: 82 }} />
    </div>
  );
}

export default App;
